export default {"src":"/_next/static/media/content_link.ba94c8e8.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};